/**
 * @generated SignedSource<<8cd8e18f6ca02f8fd03a22f166528607>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RuleConfigurationStepUserPill$data = {
  readonly email: string;
  readonly fullName: string;
  readonly id: string;
  readonly image: string;
  readonly isGuest: boolean;
  readonly " $fragmentType": "RuleConfigurationStepUserPill";
};
export type RuleConfigurationStepUserPill$key = {
  readonly " $data"?: RuleConfigurationStepUserPill$data;
  readonly " $fragmentSpreads": FragmentRefs<"RuleConfigurationStepUserPill">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RuleConfigurationStepUserPill",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGuest",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "bc588a4359e08e7930e62b924911bf7e";

export default node;
